export enum MachineStatusBulletDisplayVariant {
  HIDDEN = 'hidden',
  NOT_VISIBLE = 'notVisible',
  VISIBLE = 'visible',
}
